import { render } from "./Departament_BurimeNjerezore.vue?vue&type=template&id=32905c30&scoped=true"
import script from "./Departament_BurimeNjerezore.vue?vue&type=script&lang=js"
export * from "./Departament_BurimeNjerezore.vue?vue&type=script&lang=js"

import "./Departament_BurimeNjerezore.vue?vue&type=style&index=0&id=32905c30&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32905c30"]])

export default __exports__